import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import { get } from 'lodash'
import { usePipelineDataContextWithVariables } from '../provider/DDPDataProvider'
import Markup from '../../../atoms/Markup'

function DDPMarkup ({ pipeline, variables, accessor, type, className, style, ...rest }) {
  const { data, isLoading, error } = usePipelineDataContextWithVariables(pipeline, variables)

  const item = useMemo(() => {
    const value = get(data, accessor)
    if (value !== null && typeof value === 'object') {
      return null
    }
    if (Array.isArray(value)) {
      return null
    }

    return value
  }, [data, accessor])

  if (isLoading || error) {
    return null
  }

  return (
    <Markup value={item} type={type} className={className} style={style} {...rest} />
  )
}

DDPMarkup.propTypes = {
  /** The data pipeline to execute */
  pipeline: PropTypes.oneOfType([PropTypes.array, PropTypes.string]),

  variables: PropTypes.any,

  /** Path to the item to display */
  accessor: PropTypes.string,

  type: PropTypes.oneOf(['html', 'plain', 'markdown']),

  className: PropTypes.string,

  style: PropTypes.object
}

export default DDPMarkup
